import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import BackToTop from "@/components/feature/BackToTop";
import { useSeo } from "@/hooks/useSeo";
import { faqs } from "@/mocks/faqs";
import Hero from "./components/Hero";
import IntroSection from "./components/IntroSection";
import HotCandidates from "./components/HotCandidates";
import RankingPreview from "./components/RankingPreview";
import CategorySection from "./components/CategorySection";
import HowItWorks from "./components/HowItWorks";
import FaqCtaSection from "./components/FaqCtaSection";

export default function Home() {
  useSeo({
    title: "爆料大赛 - 爆料大赛投票评选入口 | 群众打分排名结果围观",
    description:
      "爆料大赛投票评选互动专区，查看当前入围名单与群众打分走势，参与爆料大赛投票支持心中的名场面，实时刷新排名结果与热门候选动态。",
    keywords: "爆料大赛,爆料大赛投票,爆料大赛评选,爆料大赛排名结果,爆料大赛群众打分,爆料大赛入围名单",
    path: "/",
    jsonLd: [
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: "爆料大赛",
        url: "/",
        inLanguage: "zh-CN",
        potentialAction: {
          "@type": "SearchAction",
          target: "/finalists?q={search_term_string}",
          "query-input": "required name=search_term_string",
        },
      },
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: "爆料大赛",
        url: "/",
        description: "面向网友的趣味爆料内容评选活动，由群众打分决定排名结果。",
        email: "hello@baoliaodasai.net",
      },
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faqs.slice(0, 5).map((f) => ({
          "@type": "Question",
          name: f.q,
          acceptedAnswer: { "@type": "Answer", text: f.a },
        })),
      },
    ],
  });

  return (
    <div className="min-h-screen bg-background-50 flex flex-col">
      <Header />
      <main className="flex-1">
        <Hero />
        <IntroSection />
        <HotCandidates />
        <RankingPreview />
        <CategorySection />
        <HowItWorks />
        <FaqCtaSection />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}